import React from 'react';
import { ENROLLMENT_STATUSES } from 'src/pages/enrollments/constants';
import EnrollmentWorkqueue from 'src/pages/enrollments/pages/EnrollmentWorkqueue';

const AcceptedEnrollments = () => (
  <EnrollmentWorkqueue enrollmentStatus={ENROLLMENT_STATUSES.accepted} />
);

export default AcceptedEnrollments;
